import React,{Component} from "react";
//import "../../node_modules/react-pro-sidebar/dist/css/styles.css";
import "./header/Header.css";
import "../scss/general.css";
import Cookies from "universal-cookie";
import logo from "./images/loading.gif";
import Mymodal from "./modal";
import ModalLogin from "./ModalLogin";
import config from '../config';
//import { Hidden } from "@material-ui/core";
const cookies = new Cookies();
const axios = require("axios");
//const changecontainer="container1";

export default class PayList extends Component {
    constructor(props) {

        super(props);
        this.state = {input:{},
        myitems: [],
        isLoaded: false,
            ErrMsg:<img src={logo} alt=""/>,
            months: ["","January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November","December"]
        }
    }
    handleClick(month,year){
        let input= this.state.input;
        input["month"] = month;
        input["year"] = year;
        this.setState({input});
        this.props.history.push({
            pathname: '/payslip',
            data: this.state.input // your data array of objects
          })
    }
    
    componentDidMount(){
        
        if(cookies.get("LoginID"))
        {  
            document.body.style.cursor="wait";
            let loginid = cookies.get("LoginID");
            let input=this.state.input;
            input["ID"]=loginid;
            this.setState({input,isLoaded:false});            
            axios({
                method: 'post',
                url: cookies.get("phpclass")+'/index.php/user/salary_list/',
                data: this.state.input,
                headers: {'Content-Type': 'multipart/form-data'}
            })
            .then((response)=> {
                document.body.style.cursor="default";
                this.setState({
                    isLoaded: true,
                    ErrMsg: "",
                    myitems: response.data
                });
            })
            .catch((response)=> {
                document.body.style.cursor="default";
                this.setState({ErrMsg:<Mymodal Title={config.gvr.ErrMsgs.TitleNotFound} Body={config.gvr.ErrMsgs.MsgNotFound}/>});
            });  
        }
        else
        {
            this.setState({ErrMsg:<ModalLogin mTitle={config.gvr.ErrMsgs.TitleNotLoggedin} mBody={config.gvr.ErrMsgs.MsgNotLoggedin}/>});
        }

    }
    render(){
        let isLoaded = this.state.isLoaded;
        let items = this.state.myitems;
    
        if (!isLoaded) 
        {
            return(
            <div className={config.changeDivClass}>
            <div className="center">
               {this.state.ErrMsg}
            </div>
            </div>
            );    
        } 
        else 
        {
            return (
                <div className="container1" > 
                    <br></br>                                                 
                            
                        <div width="100%" scroll="hidden"  >

                        <div className="inner-profile" >
                        <div style={{textAlign:"center",width:"100%"}}>
                        <span className="box-title" >Yearly Payslip</span>
                        </div>

                            <table style={{width:"100%"}}>
                                <thead>
                                    <tr className="tr">
                                        <th className="thm" scope="col">Month</th>
                                        <th className="thm" scope="col">Year</th>
                                        <th className="thm" scope="col">Net Salary</th>
                                        <th className="thm" scope="col"></th>
                                    </tr>
                                </thead>
                            <tbody>
                                {items.map((result ,i) => {
                                return (
                                    <tr className="trc" key={i}>
                                        <td className="tdm" >{this.state.months[result.month]}</td>
                                        <td className="tdm">{result.year}</td>
                                        <td className="tdm">{result.NET}</td>
                                        <td className="tdm"><button type="button"  onClick={() => {this.handleClick(result.month,result.year)}}>View</button></td>
                                    </tr>
                                )})}
                            </tbody>
                            </table>
                        </div>
                        </div>
                  </div>
                
              )
    }
}}